import { reactive } from "vue";

const state = reactive({
  items: [],
});

function uid() {
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function push(options) {
  const item = {
    id: uid(),
    createdAt: Date.now(),
    type: options.type || "info",
    title: options.title,
    message: options.message,
    duration: options.duration ?? 4500,
    actions: options.actions || [],
  };

  state.items.unshift(item);

  const MAX = 5;
  if (state.items.length > MAX) state.items.splice(MAX);

  return item.id;
}

function remove(id) {
  const idx = state.items.findIndex((n) => n.id === id);
  if (idx !== -1) state.items.splice(idx, 1);
}

export function useNotify() {
  return {
    state,
    push,
    remove,
    success: (message, opts = {}) =>
      push({ ...opts, message, type: "success" }),
    info: (message, opts = {}) => push({ ...opts, message, type: "info" }),
    warning: (message, opts = {}) =>
      push({ ...opts, message, type: "warning" }),
    error: (message, opts = {}) => push({ ...opts, message, type: "error" }),
  };
}
